<template>
  <div class="main-content" :style="mainContentViewHeight">
    <div class="edit-form">
      <el-tabs v-model="activeName" @tab-click="tableChange">
        <el-tab-pane label="数据集列表" name="basicInfo"> 
          <config-dataset-list v-if="isRouterAlive" :formId.sync="formId" />
        </el-tab-pane>
        <el-tab-pane label="查询参数配置" name="searchArg">
          <config-search-arg v-if="isRouterAlive" :formId.sync="formId" />
        </el-tab-pane>
        <el-tab-pane label="字段映射" name="datasetField">
          <config-dataset-field v-if="isRouterAlive" :formId.sync="formId" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
    import ConfigDatasetField from "./detail_config_dataset_field.vue";
    import ConfigDatasetList from "./detail_config_dataset_list.vue";
    import ConfigSearchArg from "./detail_config_search_arg.vue";

    export default {
  props: ["mainContentViewHeight"],
  components: { ConfigDatasetField, ConfigSearchArg,ConfigDatasetList },
  data() {
    return {
      activeName: "basicInfo",
      formId: "",
      isRouterAlive: true,
    };
  },
  activated() {
    this.formId = this.$route.params.id;
    this.loadData();
  },
  created() {
    this.formId = this.$route.params.id;
    this.loadData();
  },
  methods: {
    getDatasourceTitle(){
        if(this.dataForm.attributes!=undefined && this.dataForm.attributes.datasourceId!=undefined){
            return this.dataForm.attributes.datasourceId;
        }
        return '无'
    },
    loadData() {
      this.activeName = "basicInfo";
    },
    tableChange(tab, event) {
      this.activeName = tab.name;
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    }
     
  },

  watch: {
    $route(to, from) {
      if (window.location.href.indexOf("detailconfig") != -1) {
        this.formId = this.$route.params.id;
        this.reload();
      }
    },
  },
};
</script>
